
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

import { Bar } from 'react-chartjs-2'; ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export default function MixBarCharts(props) {
    return (
        <div style={{
            width: '100%', margin: 'auto', padding: '15px',
            boxShadow: "rgba(101, 73, 73, 0.16) 0px 1px 4px",
            borderRadius: '10px',
            backgroundColor: '#fcfcfc',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',

        }}>
            <Bar data={props.data} options={props.options} />
        </div >
    );
}